export enum TreeType {
  Normal = 'Normal',
  Flower = 'Flower',
  Bush = 'Bush',
}
